<template>
  <div class="notify">
    <!--顶部导航-->
    <Navbar title="通知中心" />
    <!--内容区域-->
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
      <div v-for="item in notifyList" :key="item.id">
        <notifyList :item="item" />
      </div>
        
      </van-list>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import notifyList from "@/components/notify/notifyList.vue";
import { getNotifyList } from "@/api/index.js";
export default {
  name: "Notify",
  components: {
    Navbar,
    notifyList
  },
  data() {
    return {
      notifyList: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      pageSize: 10,
    };
  },
  async mounted() {},
  methods: {
    onLoad() {
      this.loading = true;
      getNotifyList({ pageNumber: this.pageNumber, pageSize: this.pageSize }).then(
        (res) => {
          this.notifyList = [...this.notifyList, ...res.data.recordList];
          this.pageNumber++;
          this.finished = this.notifyList.length >= res.data.total;
          this.loading = false;
        },
      );
    },
  },
};
</script>

<style scoped lang="scss">
.notify {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f4f4;
}
.content {
  padding: 20px 16px;
}
</style>
